export interface Crop {
  id: string;
  name: string;
}

export interface Geometry {
  type: string;
  coordinates: number[][][] | number[][][][];
}

export interface Feature {
  type: string;
  properties: FeatureProperties;
  geometry: Geometry;
}

export interface FeatureProperties {
  id: string;
  name: string;
  boundaryArea: number;
  reportedArea: number;
  archived: boolean;
  propertyId: string;
  cropzones: CropZone[];
  $landType: string;
  $includedChildGeometries: unknown[];
}
export interface CropZone {
  id: string;
  name: string;
  reportedArea: number;
  boundaryArea: number;
  geometry: Geometry;
  cropSeasons: CropSeason[];
  crop: Crop;
  archived: boolean;
}

export interface CropSeason {
  status: number;
  message: string;
  id: string;
  name: string;
  crops: Crop[];
  currency: string;
  active: boolean;
}

export interface PlanCropZone {
  farmId: string;
  cropZoneIdValue: string;
  areaUnit: string;
  originalAcres: number;
  areaValue: number;
  coveragePct: number;
  boundaryArea: number;
  reportedArea: number;
  areaType: string;
  name: string;
  crop: Crop;
  features: Feature[];
  fieldName: string;
}

export interface PlanCropSeason {
  startDate: string;
  startDateEpoch: number;
  endDate: string;
  endDateEpoch: number;
  createdDate: string;
  createdDateEpoch: number;
  id: string;
  name: string;
  active: boolean;
  crops: Crop[];
  cropZoneIds: string[];
  totalArea: {
    totalArea: number;
    status: number;
    message: string;
    totalAreaUnit: string;
  };
}

const findCropSeasonIdForCropZone = (
  zone: string,
  cropSeasons: PlanCropSeason[],
  selectedCropSeasonIds: string[]
) =>
  cropSeasons.filter(
    season =>
      season.cropZoneIds?.includes(zone) &&
      selectedCropSeasonIds.includes(season.id)
  );

const getSelectedCropSeasonIds = (
  cropZones: PlanCropZone[],
  cropSeasons: PlanCropSeason[],
  selectedCropSeasonIds: string[]
) => {
  if (!cropZones.length) {
    return [];
  }

  return [
    ...new Set(
      cropZones.flatMap(cropZone => {
        const match = findCropSeasonIdForCropZone(
          cropZone.cropZoneIdValue,
          cropSeasons,
          selectedCropSeasonIds
        )[0];
        return match ? [match.id] : [];
      })
    )
  ];
};

export { findCropSeasonIdForCropZone, getSelectedCropSeasonIds };
